import { DSFlex, DSSpacer } from '@zoe/ds-web'
import styled from 'styled-components'

const StyledFeaturedInLogo = styled.div`
  a {
    width: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const FeaturedInLogos = () => {
  return (
    <StyledFeaturedInLogo>
      <DSFlex direction="column" gap={16}>
        <DSSpacer direction="vertical" size={48} breakAt={{ m: 24 }} />
        <DSFlex
          gap={32}
          justifyContent="space-between"
          alignItems="center"
          breakConfig={{
            maxViewportDirection: 'row',
            breakAt: {
              breakPoint: 'm',
              direction: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 32,
            },
          }}
        >
          <a
            href="https://www.forbes.com/sites/annahaines/2021/07/23/this-diet-is-changing-the-way-we-think-about-nutrition/"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/assets/img/logos/forbes.svg" alt="Forbes" width="128" height="32" />
          </a>

          <a
            href="https://www.theguardian.com/lifeandstyle/2022/jun/10/the-diet-that-is-right-for-you-putting-a-personalised-nutrition-app-to-the-test"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/assets/img/logos/guardian.svg" alt="The Guardian" width="148" height="49" />
          </a>
          <a
            href="https://www.newscientist.com/article/2246056-there-is-no-perfect-diet-that-works-for-every-metabolism-or-body-type/"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/assets/img/logos/new-scientist.svg" alt="New Scientist" width="165" height="23" />
          </a>
        </DSFlex>
        <DSSpacer direction="vertical" size={48} breakAt={{ m: 0 }} />

        <DSFlex
          gap={32}
          justifyContent="space-around"
          alignItems="center"
          breakConfig={{
            maxViewportDirection: 'row',
            breakAt: {
              breakPoint: 'm',
              direction: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 32,
            },
          }}
        >
          <a href="https://www.economist.com/nutrition-pod" target="_blank" rel="noreferrer">
            <img src="/assets/img/logos/economist.svg" alt="The Economist" width="178" height="54" />
          </a>
          <a
            href="https://www.telegraph.co.uk/health-fitness/nutrition/diet/lost-stone-without-ever-feeling-hungry/"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/assets/img/logos/telegraph.svg" alt="The Telegraph" width="201" height="33" />
          </a>
        </DSFlex>
      </DSFlex>
    </StyledFeaturedInLogo>
  )
}
